function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.515 9.22l9.221 9.222 9.22-9.22L12.737 0zm.911 0l8.31-8.309 8.31 8.31-8.31 8.31z",
  fill: "#999"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6e035",
  d: "M0 9.221L9.22.001l9.222 9.22-9.221 9.22z"
});

function SvgFooterSquaresBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.957 18.442",
    className: "w-full h-full"
  }, props), _ref, _ref2);
}

export default SvgFooterSquaresBlack;